import { ChipProps } from '@mui/material';
import { ApiError, useGetGroupDetailsQuery } from '@schooly/api';
import { Spin, TagSelect } from '@schooly/style';
import { FC, ReactNode } from 'react';

export type GroupTagSelectProps = {
  id: string;
  onError?: (id: string, error: ApiError) => void;
  renderLabel?: (label: string) => ReactNode;
} & Omit<ChipProps, 'label' | 'onError'>;

export const GroupTagSelect: FC<GroupTagSelectProps> = ({
  id,
  onError,
  renderLabel = (label) => label,
  ...props
}) => {
  const { data } = useGetGroupDetailsQuery(
    { id },
    {
      onError: (error) => {
        onError?.(id, error);
      },
      retry: false,
    },
  );

  return <TagSelect label={data?.group ? renderLabel(data.group.name) : <Spin />} {...props} />;
};
